"use client";

import Preview from "@/components/Preview";
import useResume from "@/lib/swr/useResume";

type ResumeInPostPageType = {
  id: string;
};

const ResumeInPostPage: React.FC<ResumeInPostPageType> = ({ id }) => {
  const { resume } = useResume(id, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  if (!resume) return null;

  return (
    <div className="flex justify-center">
      <Preview resume={resume} mode="preview" />
    </div>
  );
};

export default ResumeInPostPage;
